import Swal from "sweetalert2";
import { GETITEMINVENTORY, GETREDUCESTOCK, GETSTOCKDETAILS, GETSTOCKDETAILSXLSX, REDUCESTOCK } from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const getStockDetail = async (param) => {
  const res = await axios.post(GETITEMINVENTORY, param);

  return res;
};

export const getInventoryData = async (param) => {
  const res = await axios.post(GETSTOCKDETAILS, param);

  return res;
};

export const getStockDetailXLSX = async (param, options = {}) => {
  return await axios.post(GETSTOCKDETAILSXLSX, param, {
    ...options,
    responseType: "blob", // Ensure this is enforced
  });
};


export const addReduceReason = async (payload, callback) => {
  await axios.post(REDUCESTOCK, payload).then((res) => {
    callback(res)
    console.log("resres ", res)
    if (res?.data?.succeeded) {
      Swal.fire({
        text: "Successfully added",
        icon: "success",
        ...swalAlertPopProps,
      });
    }

    else {
      Swal.fire({
        text: res?.data?.message,
        icon: "error",
        ...swalAlertPopProps,
      });
    }
  }).catch((err) => {
    console.log(err)
  })
}


export const getReduceStockDetails = async (payload, callback) => { 
  await axios.post(GETREDUCESTOCK, payload).then((response) => {
    callback(response)
  }).catch((err) => {
    console.log(err)
  })
   
}